var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loader",class:[ _vm.isActive ? 'is-active' : 'is-inactive', _vm.isVisible ? 'is-visible' : 'is-hidden' ]})}
var staticRenderFns = []

export { render, staticRenderFns }